export default "__VITE_PUBLIC_ASSET__50d4315b__"